import { styled } from "styled-components";
import { Centering } from "styles/mixinStyles";

const UrlPageContainer = styled(Centering)`
  flex-direction: column;
  width: 100vw;
`;

export { UrlPageContainer };
